import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { defineComponent, ref, onMounted, onBeforeUnmount, watch } from "vue";
import Header from "@/components/header.vue";
// import Banner from "@/components/home/banner.vue";
import Content from "@/components/home/content.vue";
import Footer from "@/components/footer.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const headerScroll = ref<any>(null);
const myDivH = ref<number>(0);
const oldScrollTop = ref<number>(0); // 记录上一次滚动结束后的滚动距离
const scrollTop = ref<number>(0); // 记录当前的滚动距离
const scrollHandle = () => {
  scrollTop.value = window.scrollY; //滚动条距离浏览器顶部高度
};
onMounted(() => {
  headerScroll.value.setBgColor(0); //将 header.vue组件的背景设置为透明
  window.addEventListener("scroll", scrollHandle);
});
onBeforeUnmount(() => {
  window.removeEventListener("scroll", scrollHandle);
});

watch(
  () => scrollTop.value,
  (newValue, oldValue) => {
    setTimeout(() => {
      if (newValue === window.scrollY) {
        // 延时执行后当newValue等于window.scrollY，代表滚动结束
        // console.log('滚动结束');
        oldScrollTop.value = newValue; // 每次滚动结束
        if (myDivH) {
          let i = scrollTop.value / myDivH.value;
          //调用子组件 header.vue 中的方法setBgColor，设置背景色
          if (i > 1) {
            headerScroll.value.setBgColor(1);
          } else {
            headerScroll.value.setBgColor(i.toFixed(2));
          }
        }
      }
    }, 20); // 需要使用延时器，否则每次newValue和window.scrollY都相等，无法判断，20ms刚好大于watch的侦听周期，故延时20ms
    if (oldScrollTop.value === oldValue) {
      // 每次滚动开始时oldScrollTop与oldValue相等
      console.log("滚动开始");
    }
  }
);
const parentMenuId = ref<number>(1);
const menuTop = ref(null);
const menuId = (val: number) => {
  parentMenuId.value = val;
};

return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_backtop = _resolveComponent("el-backtop")!

  return (_openBlock(), _createElementBlock("div", {
    class: "common-layout",
    ref_key: "menuTop",
    ref: menuTop
  }, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, { class: "common-layout-header" }, {
          default: _withCtx(() => [
            _createVNode(Header, {
              ref_key: "headerScroll",
              ref: headerScroll,
              onScrollId: menuId
            }, null, 512)
          ]),
          _: 1
        }),
        _createVNode(_component_el_main, { class: "common-layout-main" }, {
          default: _withCtx(() => [
            _createVNode(Content, { "parent-menu": parentMenuId.value }, null, 8, ["parent-menu"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_footer, {
          class: "common-layout-footer",
          height: "auto"
        }, {
          default: _withCtx(() => [
            _createVNode(Footer)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_backtop, {
      right: 50,
      bottom: 50
    })
  ], 512))
}
}

})